import _slicedToArray from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/regenerator/index.js";
import { __rest, __awaiter } from './../../external/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { DialogContent, Dialog } from '@mui/material';
import { Formik, Form } from 'formik';
import React, { useState, useCallback, useEffect } from 'react';
import '@apollo/client';
import { getErrorMessage } from '../../utils/utils.js';
import { displayFieldError } from '../../utils/inputUtils.js';
import { alertError } from '../../utils/popupUtils.js';
import '../../utils/stylesUtils.js';
import { DialogTitleWithClose } from '../fragments/DialogTitleWithClose/DialogTitleWithClose.js';
import '../ConfirmDialog/ConfirmContext.js';
import { useConfirm } from '../ConfirmDialog/useConfirm.js';
import { DialogSaveDeleteActions } from '../fragments/DialogSaveDeleteActions/DialogSaveDeleteActions.js';
/** A custom form dialog with formik form wrapper and (optional) save and delete buttons */

var FormikDialog = function FormikDialog(_a) {
  var open = _a.open,
      maxWidth = _a.maxWidth,
      formikConfig = _a.formikConfig,
      onExited = _a.onExited,
      innerDialogProps = __rest(_a, ["open", "maxWidth", "formikConfig", "onExited"]);

  var onDeleteSubmit = formikConfig.onDeleteSubmit,
      onSaveSubmit = formikConfig.onSaveSubmit,
      errorsToFieldName = formikConfig.errorsToFieldName,
      _formikConfig$confirm = formikConfig.confirmDelete,
      confirmDelete = _formikConfig$confirm === void 0 ? true : _formikConfig$confirm;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      submitDelete = _useState2[0],
      setSubmitDelete = _useState2[1];

  var showDeleteConfirm = useConfirm({
    title: typeof confirmDelete === "string" ? confirmDelete : "Confirm to delete",
    confirmText: "Delete"
  });

  var onSubmit = function onSubmit(values, formikHelpers) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var handleSuccess, errorsToFieldNamesObj;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              handleSuccess = function handleSuccess() {
                innerDialogProps.onClose();
              };

              _context.prev = 1;

              if (!submitDelete) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return onDeleteSubmit(values, formikHelpers);

            case 5:
              _context.next = 9;
              break;

            case 7:
              _context.next = 9;
              return onSaveSubmit(values, formikHelpers);

            case 9:
              handleSuccess();
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);

              if (errorsToFieldName) {
                errorsToFieldNamesObj = typeof errorsToFieldName === "function" ? errorsToFieldName() : errorsToFieldName;

                if (!displayFieldError(_context.t0, formikHelpers, errorsToFieldNamesObj)) {
                  alertError(getErrorMessage(_context.t0));
                }
              } else {
                alertError(getErrorMessage(_context.t0));
              }

            case 15:
              setSubmitDelete(false);
              formikHelpers.setSubmitting(false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    }));
  };

  var onDelete = useCallback(function () {
    if (confirmDelete) showDeleteConfirm(function () {
      return setSubmitDelete(true);
    });else setSubmitDelete(true);
  }, [setSubmitDelete, confirmDelete, showDeleteConfirm]);
  return jsx(Dialog, Object.assign({
    open: open,
    onClose: innerDialogProps.onClose,
    maxWidth: maxWidth,
    fullWidth: true,
    TransitionProps: {
      onExited: onExited
    }
  }, {
    children: jsx(Formik, Object.assign({}, Object.assign(Object.assign({}, formikConfig), {
      onSubmit: onSubmit
    }), {
      children: function children(formikProps) {
        return jsx(InnerForm, Object.assign({
          submitDelete: submitDelete,
          onDelete: formikConfig.onDeleteSubmit ? onDelete : undefined,
          formikProps: formikProps
        }, innerDialogProps));
      }
    }))
  }));
};

function InnerForm(_a) {
  var submitDelete = _a.submitDelete,
      formikProps = _a.formikProps,
      rest = __rest(_a, ["submitDelete", "formikProps"]);

  var isSubmitting = formikProps.isSubmitting,
      submitForm = formikProps.submitForm;
  useEffect(function () {
    if (submitDelete) {
      submitForm();
    } // eslint-disable-next-line

  }, [submitDelete]);
  return jsx(Form, {
    children: jsx(ItemOperationDialogInner, Object.assign({
      loadingDelete: isSubmitting && submitDelete,
      loadingSave: isSubmitting && !submitDelete,
      formikProps: typeof rest.children === "function" ? formikProps : null
    }, rest))
  });
}
/** Memoized to not rerender when formik context changes (if children is not a function) */
// eslint-disable-next-line


var ItemOperationDialogInner = React.memo(function (_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      title = _ref.title,
      onDelete = _ref.onDelete,
      loadingSave = _ref.loadingSave,
      loadingDelete = _ref.loadingDelete,
      saveText = _ref.saveText,
      noFooter = _ref.noFooter,
      formikProps = _ref.formikProps;
  return jsxs(Fragment, {
    children: [typeof title === "string" ? jsx(DialogTitleWithClose, Object.assign({
      onClose: onClose
    }, {
      children: title
    })) : title, jsx(DialogContent, Object.assign({
      dividers: true
    }, {
      children: typeof children === "function" ? children(formikProps) : children
    })), !noFooter && jsx(DialogSaveDeleteActions, {
      loadingSave: loadingSave,
      onDelete: onDelete,
      loadingDelete: loadingDelete,
      saveText: saveText
    })]
  });
});
export { FormikDialog };